import { RectificationType } from './types';

interface GetPathNameParams {
  type: RectificationType;
  path: string;
  isReceipt?: boolean;
}

export const getPathName = ({
  type,
  path,
  isReceipt,
}: GetPathNameParams): string => {
  const isPartialCorrective = type === RectificationType.PARTIAL;

  if (isReceipt && isPartialCorrective) {
    return `${path}/tickets-rectify-substitute/document-data`;
  }

  if (!isReceipt && isPartialCorrective) {
    return `${path}/rectify-substitute/document-data`;
  }

  return `${path}/rectify`;
};
